import { useEffect, useState } from 'react';

import { SAVED_CARDS_LOADING_TIMEOUT_MS } from './WalletSavedCardsSection.constants';

// Skeleton state. `savedCards === undefined` means UXL hasn't resolved; the timeout
// guarantees we don't hang where no producer exists (unauth local, author mode).
export const useSavedCardsLoadingState = (
  savedCards: unknown,
  options?: { timeoutMs?: number; disable?: boolean }
): boolean => {
  const { timeoutMs = SAVED_CARDS_LOADING_TIMEOUT_MS, disable = false } = options ?? {};
  const [timedOut, setTimedOut] = useState(false);
  const storeIsPending = savedCards === undefined;

  useEffect(() => {
    if (disable || !storeIsPending) {
      setTimedOut(false);
      return undefined;
    }
    const handle = window.setTimeout(() => setTimedOut(true), timeoutMs);
    return () => window.clearTimeout(handle);
  }, [disable, storeIsPending, timeoutMs]);

  if (disable) return false;
  return storeIsPending && !timedOut;
};
